import classNames from 'classnames';
import {TProductListView} from 'modules/products/types';
import React, {FC, ChangeEventHandler, ReactNode, useMemo} from 'react';
import style from './style.module.scss';
import Icon from 'components/Icon';

export interface IListItem {
    hint: string;
    icon: ReactNode;
    value: string;
}

export const switcherList = [
    {
        hint: 'Краткий режим каталога',
        icon: <Icon icon={'cards-view'} />,
        value: 'tile',
    },
    {
        hint: 'Подробный режим каталога',
        icon: <Icon icon={'list-view'} />,
        value: 'list',
    },
];

export interface IProps {
    className?: string;
    name?: string;
    value?: TProductListView;
    onChange?: ChangeEventHandler<HTMLInputElement>;
    list?: IListItem[];
}

export const ViewSwitcher: FC<IProps> = ({className, name = 'view-switcher', value, onChange, list = switcherList}) => {
    const icons = useMemo(() => {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        return list.map(({value: iconValue, icon, hint}) => {
            const inputId = `${name}-${iconValue}`;

            return (
                <label
                    className={classNames(style.label, {
                        [style.disabled]: value === iconValue,
                    })}
                    htmlFor={inputId}
                    key={inputId}
                >
                    <input
                        checked={value === iconValue}
                        className={style.checkbox}
                        id={inputId}
                        name={name}
                        onChange={onChange}
                        type={'radio'}
                        value={iconValue}
                    />
                    <div className={style.inner} title={hint}>
                        {icon}
                    </div>
                </label>
            );
        });
    }, [list, name, value, onChange]);

    return (
        <div className={classNames(style.switch, className)}>
            <div className={style.container}>{icons}</div>
        </div>
    );
};
